import { ctTime, dayLabel, hhmmLabel, todayCT } from "@/lib/calendar";

const disc = (list) => (list.length === 2 ? "H+P" : list[0] === "hitting" ? "Hitting" : "Pitching");

export function DayEvents({ b, compact }) {
  const items = [
    ...b.windows.map((w) => ({ k: `w${w.id}`, cls: "text-emerald-300/90", t: `Open ${hhmmLabel(w.start)}–${hhmmLabel(w.end)} · ${disc(w.disciplines)}` })),
    ...b.openings.map((o) => ({ k: `o${o.id}`, cls: "text-emerald-300", t: `+ Extra ${ctTime(o.start)}–${ctTime(o.end)}` })),
    ...b.groups.map((g) => ({ k: `g${g.session_id}`, s: g.start, cls: "text-white/80", t: `${ctTime(g.start)} ${g.title}` })),
    ...b.lessons.map((l) => ({ k: `l${l.id}`, s: l.start, cls: "text-[#60a5fa] font-bold", t: `${ctTime(l.start)} ${l.athlete_name || "Lesson"}${l.status === "held" ? " (held)" : ""}` })),
    ...b.blocks.map((x) => ({ k: `b${x.id}`, cls: "text-amber-300", t: `Blocked ${x.reason || ""}` })),
  ];
  const shown = compact ? items.slice(0, 4) : items;
  return (
    <div className="mt-1.5 space-y-1">
      {shown.map((i) => <p key={i.k} className={`text-[11px] leading-tight break-words ${i.cls}`}>{i.t}</p>)}
      {compact && items.length > 4 && <p className="text-[11px] text-white/40">+{items.length - 4} more</p>}
    </div>
  );
}

export function WeekView({ days, buckets, selected, onSelect }) {
  const today = todayCT();
  return (
    <div data-testid="cal-week" className="grid grid-cols-1 md:grid-cols-7 gap-2">
      {days.map((d) => (
        <button key={d} data-testid={`cal-day-${d}`} onClick={() => onSelect(d)}
          className={`flex flex-col justify-start items-stretch text-left rounded-xl border p-3 min-h-[64px] md:min-h-[170px] transition-colors ${selected === d ? "border-[#2563EB] bg-[#2563EB]/10" : "border-white/10 hover:border-white/30"}`}>
          <p className={`text-xs font-bold uppercase tracking-wider ${d === today ? "text-[#60a5fa]" : "text-white/50"}`}>{dayLabel(d)}</p>
          <DayEvents b={buckets[d]} />
        </button>
      ))}
    </div>
  );
}

const Dot = ({ n, cls }) => (n ? <span className={`inline-flex items-center justify-center min-w-[18px] h-[18px] rounded-full px-1 text-[10px] font-bold ${cls}`}>{n}</span> : null);

export function MonthView({ days, month, buckets, selected, onSelect }) {
  const today = todayCT();
  return (
    <div data-testid="cal-month">
      <div className="grid grid-cols-7 gap-1 mb-1">{["M", "T", "W", "T", "F", "S", "S"].map((x, i) => <p key={i} className="text-center text-[11px] font-bold text-white/40">{x}</p>)}</div>
      <div className="grid grid-cols-7 gap-1">
        {days.map((d) => {
          const b = buckets[d];
          const open = d >= today && b.open;
          return (
            <button key={d} data-testid={`cal-day-${d}`} onClick={() => onSelect(d)}
              className={`flex flex-col justify-start rounded-lg border p-1.5 sm:p-2 min-h-[58px] sm:min-h-[92px] text-left transition-colors ${selected === d ? "border-[#2563EB] bg-[#2563EB]/10" : "border-white/10 hover:border-white/30"} ${d.slice(0, 7) !== month ? "opacity-35" : ""}`}>
              <p className={`text-xs font-bold ${d === today ? "text-[#60a5fa]" : "text-white/70"}`}>{Number(d.slice(8))}</p>
              <div className="mt-1 flex flex-wrap gap-0.5">
                {open && <span className="w-2 h-2 rounded-full bg-emerald-400 mt-1" title="Open for lessons" />}
                <Dot n={b.lessons.length} cls="bg-[#2563EB] text-white" />
                <Dot n={b.groups.length} cls="bg-white/80 text-[#0B0F19]" />
                {b.blocks.length > 0 && <span className="w-2 h-2 rounded-full bg-amber-400 mt-1" title="Blocked" />}
              </div>
            </button>
          );
        })}
      </div>
      <p className="mt-3 flex flex-wrap gap-4 text-[11px] text-white/50"><span><i className="inline-block w-2 h-2 rounded-full bg-emerald-400 mr-1" />Open</span><span><i className="inline-block w-2 h-2 rounded-full bg-[#2563EB] mr-1" />Lessons</span><span><i className="inline-block w-2 h-2 rounded-full bg-white/80 mr-1" />Group classes</span><span><i className="inline-block w-2 h-2 rounded-full bg-amber-400 mr-1" />Blocked</span></p>
    </div>
  );
}
